import { getI18nPropertyValue } from '@/i18n'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('company', [
      'companyThemeSetting'
    ]),
    hasCustomTheme () {
      return this.companyThemeSetting?.has_custom_theme
    },
    companyInfo () {
      return this.companyThemeSetting?.company || {}
    },
    companyName () {
      if (this.companyInfo.has_referral_share) {
        return getI18nPropertyValue(this.companyInfo.root_company, 'cn_name', 'name')
      }
      return getI18nPropertyValue(this.companyInfo, 'cn_name', 'name')
    },
    headerSetting () {
      return this.companyThemeSetting?.headerSetting || {}
    },
    footerSetting () {
      return this.companyThemeSetting?.footerSetting || {}
    },
    commonSetting () {
      return this.companyThemeSetting?.commonSetting || {}
    },
    personalHomePCSetting () {
      return this.companyThemeSetting?.personalHomePCSetting || {}
    },
    personalHomeMobileSetting () {
      return this.companyThemeSetting?.personalHomeMobileSetting || {}
    },
    loginSetting () {
      return this.companyThemeSetting?.loginSetting || {}
    },
    companyDetailSetting () {
      return this.companyThemeSetting?.companyDetailSetting || {}
    },
    customColor () {
      return this.commonSetting.customColor || '#0096cc'
    },
    mobileCustomMenuList () {
      if (!this.hasCustomTheme) {
        return null
      }
      return this.companyThemeSetting.personalHomeMobileSetting.menuList
    },
    pcCustomMenuList () {
      if (!this.hasCustomTheme) {
        return null
      }
      return this.companyThemeSetting.personalHomePCSetting.menuList
    },
    showPhoneIcon () {
      return this.hasCustomTheme ? this.headerSetting.phoneIcon : true
    },
    logoPosition () {
      return this.headerSetting.logoPosition || 'left'
    },
    showCompanyLogo () {
      return this.hasCustomTheme ? this.headerSetting.showCompanyLogo : true
    },
    showCompanyName () {
      return this.hasCustomTheme ? this.headerSetting.showCompanyName : true
    },
    userMenuBackgroundColor () {
      return this.headerSetting.userMenu?.backgroundColor
    },
    userMenuFontColor () {
      return this.headerSetting.userMenu?.fontColor
    }
  }
}
